import React, { useState } from "react";
import { CheckCircle2 } from "lucide-react";
import service from "../../Service/Service";
import "./NewsletterStrip.css";

const NewsletterStrip = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;

    setStatus("submitting");
    setErrorMsg("");

    try {
      await service.addContact({
        name: "Deal Alert Subscriber",
        email: email.trim(),
        phone: "",
        subject: "Deal Alerts",
        message: "Subscribed to deal alerts from homepage newsletter strip.",
      });
      setStatus("success");
      setEmail("");
    } catch {
      setStatus("error");
      setErrorMsg("Something went wrong. Please try again.");
    }
  };

  return (
    <section className="newsletter-strip">
      <div className="newsletter-strip-glow" aria-hidden="true" />

      <div className="newsletter-strip-inner">
        <p className="newsletter-strip-badge">Deal Alerts</p>
        <h2 className="newsletter-strip-title">Never miss a flight deal again</h2>
        <p className="newsletter-strip-text">
          Get exclusive discounts and last-minute deals sent straight to your inbox. No spam, unsubscribe any time.
        </p>

        {status === "success" ? (
          <div className="newsletter-strip-success">
            <CheckCircle2 />
            You're on the list — we'll be in touch!
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="newsletter-strip-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              className="newsletter-strip-input"
              disabled={status === "submitting"}
            />
            <button
              type="submit"
              className="newsletter-strip-btn"
              disabled={status === "submitting"}
            >
              {status === "submitting" ? "Signing up..." : "Get Deal Alerts"}
            </button>
          </form>
        )}

        {status === "error" && (
          <p className="newsletter-strip-error">{errorMsg}</p>
        )}

        <p className="newsletter-strip-footnote">
          We respect your privacy. No spam, ever.
        </p>
      </div>
    </section>
  );
};

export default NewsletterStrip;
